import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { ModalController, IonRouterOutlet } from '@ionic/angular';
import { CguPage } from '../cgu/cgu.page';
import { FirebaseService } from '../../../services/firebase.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {

  validations_form: FormGroup;
  errorMessage: string = '';
  successMessage: string = '';

  validation_messages = {
    'email': [
      { type: 'required', message: 'L\'adresse email est obligatoire' },
      { type: 'pattern', message: 'Ton adresse email n\'est pas valide' }
    ],
    'password': [
      { type: 'required', message: 'Le mot de passe est obligatoire' },
      { type: 'minlength', message: 'Le mot de passe doit faire minimum 5 caractères.' }
    ],
    'code_commune': [
      { type: 'required', message: 'Le code commune est obligatoire' },
      { type: 'minlength', message: 'Le code commune doit faire minimum 6 caractères.' },
      { type: 'maxlength', message: 'Le code commune doit faire maximum 9 caractères.' }
    ],
    // 'pseudo': [
    //   { type: 'required', message: 'Le pseudo est obligatoire' },
    //   { type: 'minlength', message: 'Le pseudo doit faire minimum 2 caractères.' }
    // ],
    'cgu': [
      { type: 'required', message: 'L\'acception des cgu et de la politique de confidentialité est obligatoire' }
    ]
  };

  constructor(
    private authService: AuthService,
    private firebaseService: FirebaseService,
    private formBuilder: FormBuilder,
    private modalCtrl: ModalController,
    private modalController: ModalController,
    private router: Router
  ) { }

  ngOnInit() {
    this.validations_form = this.formBuilder.group({
      email: new FormControl('', Validators.compose([
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
      ])),
      password: new FormControl('', Validators.compose([
        Validators.minLength(5),
        Validators.required
      ])),
      code_commune: new FormControl('', Validators.compose([
        Validators.minLength(6),
        Validators.maxLength(9),
        Validators.required
      ])),
      // pseudo: new FormControl('', Validators.compose([
      //   Validators.minLength(2),
      //   Validators.required
      // ])),
      cgu: new FormControl(false, Validators.compose([
        Validators.requiredTrue
      ])),
    });
    this.checkCommune("6R69TZ8");
  }

  async toogleCGV() {
    console.log("toogleCGV", this.validations_form.value.cgu);
    if (this.validations_form.value.cgu)
      return;
    else
      this.showCGV();

  }
  async showCGV() {
    const modal = await this.modalController.create({
      component: CguPage,
      swipeToClose: true
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data);
    if (data.cgu != null) {
      if (!data.cgu)
        this.validations_form.controls["cgu"].setValue(false);
      if (data.cgu)
        this.validations_form.controls["cgu"].setValue(true);
    }
  }

  async checkCommune(code_commune) {
    let commune = await this.firebaseService.searchCommunes('code', code_commune);
    console.log('checkCommune', commune);
    return commune;
  }
  async checkAgglo(code_commune) {
    let agglo = await this.firebaseService.searchAgglos('code', code_commune);
    console.log('checkAgglo', agglo);
    return agglo
  }

  async tryRegister(value) {
    console.log("tryRegister", value);
    value.email = value.email.replace(/\s/g, '');
    if (!value.email || value.email == '')
      return this.errorMessage = this.validation_messages.email[0].message;
    if (!value.password || value.password == '')
      return this.errorMessage = this.validation_messages.password[0].message;
    // if (!value.pseudo || value.pseudo == '')
    //   return this.errorMessage = this.validation_messages.pseudo[0].message;
    if (!value.cgu)
      return this.errorMessage = this.validation_messages.cgu[0].message;
    if (!value.code_commune)
      return this.errorMessage = this.validation_messages.code_commune[0].message;

    let commune = await this.checkCommune(value.code_commune);
    let agglo = await this.checkAgglo(value.code_commune);
    console.log("checkCommune result", commune);
    if (!commune && !agglo)
      return this.errorMessage = "Le code commune ou agglo est incorrect"

    // 6R69TZ8
    this.authService.doRegister(value)
      .then(async res => {

        // console.log("doRegister", res);
        let user: any = {
          email: value.email,
          pseudo: value.email.split("@")[0],
          created_at: new Date().toISOString(),
        }
        if (commune) {
          user.status = 2;
          user.commune_id = commune["id"];
          user.commune_locality = commune["locality"];
          user.code_commune = value.code_commune;
        } else if (agglo) {
          user.status = 4;
          user.code_agglo = value.code_commune;
        }
        this.firebaseService.createUser(res.user.uid, user)
      })
      .then(res => {
        // console.log(res);
        this.errorMessage = "";
        this.successMessage = "Votre compte à été crée, vous allez accéder au tableau de bord.";
        this.close();
      }, err => {
        console.error(err);
        this.errorMessage = err.message;
        this.successMessage = "";
      })
  }


  close(goTo = null) {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalCtrl.dismiss({
      'dismissed': true,
      'goTo': goTo
    });
  }

  goLoginPage() {
    this.close('login')
  }

}
